<template>
  <div class="bg-gray">
    <navigation-bar />
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12" style="padding-top:20px;">
            <div class="row">
              <div class="col-xs-12 col-sm-12 text-left">
                <div class="row">
                  <div class="col-sm-6">
                    <h1 style="float:left;">Update Listing</h1>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Service</label>
                      <h5>{{store.state.listing.serviceName}}</h5>
                    </div>
                      <div style="margin-left:10px;margin-bottom:10px;">
                        <small>{{store.state.selectedService.description}}</small>
                      </div>
                  </div>
                  <div class="col-sm-6" v-for="(field,idx) in store.state.listing.fields" :key="field.id">
                    <div class="form-group">
                      <label>{{field.fieldName}}</label>
                      <div v-if="field.fieldType == 'Text' || field.fieldType == 'Email' || field.fieldType == 'Website' || field.fieldType == 'Number'">
                        <input v-on:keyup="$forceUpdate()" class="form-control" v-model="field.value" type="text" :placeholder="field.fieldName" />
                        <span v-if="field.characterLimit > 0">
                          {{field.value.length}}/{{field.characterLimit}}
                        </span>
                      </div>
                      <div v-if="field.fieldType == 'Text Area'">
                        <textarea v-on:keyup="$forceUpdate()" class="form-control" v-model="field.value" type="text" :placeholder="field.fieldName" />
                        <span v-if="field.characterLimit > 0">
                          {{field.value.length}}/{{field.characterLimit}}
                        </span>
                      </div>
                      <div v-if="field.fieldType == 'Date'">
                        <input class="form-control" v-model="field.value" type="date" :placeholder="field.name" />
                      </div>
                      <div v-if="field.fieldType == 'Y/N'">
                        <select class="form-control" v-model="field.value">
                          <option value="">---Select One---</option>
                          <option value="Y">Yes</option>
                          <option value="N">No</option>
                        </select>
                      </div>
                      <div v-if="field.fieldType == 'Select Dropdown'">
                        <select class="form-control" v-model="field.value">
                          <option value="">--Select One---</option>
                          <option v-for="option in field.fieldOptions" :key="option" :value="option">{{option}}</option>
                        </select>
                      </div>
                      <div v-if="field.fieldType == 'Multi Select Dropdown'">
                        <div class="row">
                          <div class="col-sm-6"  v-for="option in field.fieldOptions" :key="option">
                            <div class="form-check">
                              <label style="width:200px;background:white;" :for="'default-' + option" class="btn btn-default btn-blue">
                                <span style="float:left;">{{option}} </span>
                                <input :ref="`multi_${idx}_${option}`" @click="multiSelectClick($event,field,option,idx)" style="float:right;" type="checkbox" :id="'default-' + option" class="badgebox">
                                <span class="badge">&check;</span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>City</label>
                      <input v-on:keyup="$forceUpdate()" class="form-control" v-model="store.state.listing.city" type="text" placeholder="City" />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>State</label>
                      <select class="form-control" v-model="store.state.listing.state">
                        <option value></option>
                        <option v-for="state in utils.states()" :key="state">{{state}}</option>
                      </select>
                    </div>
                  </div>
                </div>


              <hr>
              <div
                class="row"
                v-if="store.state.listing.priceName == 'Large' || store.state.listing.serviceId == 1"
              >
                  <div class="col-sm-12">
                  <p>
                    <strong>Upload a Photo</strong>
                  </p>
                  <small>You can upload a photo or logo to appear next to your listing. <br>We recommend uploading a square image to avoid cropping/cutting off your image.</small>
                  <br>
                  <div class="row">
                    <div class="col-sm-12" style="text-align:center;margin-top:20px;">
                      <img v-if="store.state.listing.photo" width="100px" height="100px" style="object-fit:cover;" :src="fileUrl(store.state.listing.photo)"/>
                      <br><br>

                      <file-selector  
                        accept-extensions=".jpg,.png,.jpeg"
                        :multiple="false"
                        :max-file-size="10 * 1024 * 1024"
                        @validated="handleFilesValidated"
                        @changed="handleFilesChanged"
                        ><button class="btn btn-blue">Select a Logo/Image</button>
                        </file-selector
                      >
                      <button style="margin-top:20px;" @click="removePhoto" v-if="store.state.listing.photo" class="btn btn-primary btn-orange">Remove Photo</button>
                      
                    </div>
                  </div>
                    </div>

                                        <div class="col-sm-12">
                      <p>
                        <strong>Customize Colors</strong>
                      </p>
                      <div class="row">
                        <div class="col-12 col-sm-6">
                          <label>Background Color</label>
                          <chrome v-model="store.state.listing.backgroundColor" />
                        </div>
                        <div  class="col-12 col-sm-6">
                          <label>Text Color</label>
                          <chrome v-model="store.state.listing.textColor" />
                        </div>
                      </div>
                      

                  </div>
              </div>
              <hr>


                  <div class="row">
                    <div class="col-sm-12 text-center" style="margin-top:50px;">
                      <div class="form-group">
                        <button :disabled="store.state.loading" @click="updateListing" style="width:250px;height:50px;font-size:x-large;" class="btn btn-primary btn-blue">Update Listing</button>
                      </div>
                    </div>
                  </div>
            </div>
            </div>
            <br>
        </div>
      </div>
    </div>
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
import NavigationBar from '../nav/NavigationBar'
import DashboardFooter from '../nav/Footer'
import Utils from '@/Utils/Utils'
import Navigator from '@/router/navigator'
import EditListingStore from './EditListingStore'
import AccountSessionUtils from './AccountSessionUtils'
import moment from 'moment'
import { Chrome } from 'vue-color'

export default {
  name: 'EditListing',
  components: {
    NavigationBar,
    DashboardFooter,
    Chrome
  },
  data () {
    return {
      nav: Navigator,
      store: EditListingStore,
      accountUtils: AccountSessionUtils,
      utils: Utils
    }
  },
  mounted () {
    this.store.reset()
    this.accountUtils.authorize((userId) => {
      this.store.state.currentUserId = userId;
      if(userId == "0"){
        this.nav.goRegister(this,"EditListing")
        return
      }
      
      this.store.state.listingId = this.$route.params.listingId
      this.getListing()
    },(err) => {
      this.$toasted.show(err, { type: 'error', duration: 2500 })
    }, () => {
        this.nav.goMaintenance(this)
    })
  },
  methods: {
    selectOptions: function(field){
      return field.selectOptions.split(",");
    },
    multiSelectClick:function($event,field,option,index){
      if($event.target.checked){
        if(!this.store.state.listing.fields[index].value.includes(option)){
          this.store.state.listing.fields[index].value.push(option);
        }
      }else{
        this.store.state.listing.fields[index].value = this.store.state.listing.fields[index].value.filter(it => {
          return it != option
        });
      }
    },
    updateListing:function(){
      let errors = this.store.validate()
      if(errors) {
        this.$toasted.show(errors, { type: 'error', duration: 2500 })
        return
      }

      this.store.updateListing((data) => {
        this.$toasted.show('Listing Updated', { type: 'success', duration: 2500 })
        this.getListing()
      }, (err) => {
        this.$toasted.show(err, { type: 'error', duration: 2500 })
      }, () => {
        this.nav.goMaintenance(this)
      })
    },
    getListing() {
      this.store.getListing(() => {
        this.$forceUpdate()
        setTimeout(() => {
            this.store.state.listing.fields.forEach((it,idx) => {
            if(it.fieldType == "Multi Select Dropdown") {
              this.selectMutliDropdownOptions(it,idx)
            }
          });
        },1000)

        this.$forceUpdate()
      }, (err) => {
        this.$toasted.show(err, { type: 'error', duration: 2500 })
      }, () => {
        this.nav.goMaintenance(this)
      })
    },
    selectMutliDropdownOptions(field,idx) {
      field.value.forEach(option => {
        let inputs = this.$refs['multi_' + idx + "_" + option]
        inputs[0].checked = true
      })
    },
    handleFilesValidated(result, files) {
      console.log("Validation result: " + result);
    },

    handleFilesChanged(files) {
      if(files.length == 1) {
        this.store.state.listing.photo = files[0]
        this.store.state.listing.didChangePhoto = true
        this.$forceUpdate()
      }
    },
    fileUrl(file) {
      if(typeof file == 'string') {
        return `https://api.everythingcheeranddance.com/public/photo?key=${file}`
      }
      return URL.createObjectURL(file);
    },
    removePhoto() {
      this.store.state.listing.photo = null
      this.store.state.listing.didRemovePhoto = 'y'
      this.$forceUpdate()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Hiding the checkbox, but allowing it to be focused */
.badgebox
{
    opacity: 0;
}

.badgebox + .badge
{
    /* Move the check mark away when unchecked */
    display:none;
    /* Makes the badge's width stay the same checked and unchecked */
	width: 27px;
}

.badgebox:checked + .badge
{
    /* Move the check mark back when checked */
	display:block;
}

.badge{
    float: right;
    margin-top: 3px;
    padding-right: 0px;
    text-align: right;
}

.btn-blue {
  color:white;
}
</style>



// WEBPACK FOOTER //
// src/components/account/EditListing.vue